<template>
    <el-menu :default-active="activeMenu" class="el-menu-vertical-demo">
        <template v-for="item in menuItems">
            <el-menu-item :index="item.index" :key="item.index" v-if="!item.isSub" @click="!item.isSub && handleMenuItemClick(item.path)">
                <span slot="title">{{ item.name }}</span>
            </el-menu-item>

            <el-submenu :index="item.index" :key="item.index" v-if="item.isSub">
                <template slot="title">
                    <span slot="title" style="padding-left: 20px">{{ item.name }}</span>
                </template>
                <el-menu-item v-for="sub in item.sub" :key="sub.index" :index="sub.index" text-color="#000" active-text-color="#fff" @click="handleMenuItemClick(sub.path)">
                    {{ sub.name }}
                </el-menu-item>
            </el-submenu>
        </template>
    </el-menu>
</template>

<script>
export default {
    data() {
        return {
            activeMenu: '',
            menuItems: [
                {
                    index: '1',
                    name: 'Prompt List',
                    path: '/prompt',
                    isSub: false,
                },
                {
                    index: '2',
                    name: 'Visual Prompt List',
                    path: '/visual-prompt',
                    isSub: false,
                },
                {
                    index: '14',
                    name: 'GPTS列表',
                    path: '/gpts-list',
                    isSub: false,
                },
                {
                    index: '3',
                    name: 'Blog',
                    path: '',
                    isSub: true,
                    sub: [
                        {
                            index: '3-1',
                            name: '展示位',
                            path: '/placement-blog',
                            isSub: false,
                        },
                        {
                            index: '3-2',
                            name: '列表',
                            path: '/list-blog',
                            isSub: false,
                        },
                    ],
                },
                {
                    index: '4',
                    name: '用户列表',
                    path: '/account',
                    isSub: false,
                },
                {
                    index: '5',
                    name: '手动添加积分列表',
                    path: '/manual-points',
                    isSub: false,
                },
                {
                    index: '6',
                    name: '渠道列表',
                    path: '/channel',
                    isSub: false,
                },
                {
                    index: '7',
                    name: '优化列表',
                    path: '/optimize',
                    isSub: false,
                },
                {
                    index: '8',
                    name: '评分列表',
                    path: '/rating',
                    isSub: false,
                },
                {
                    index: '9',
                    name: '活动列表',
                    path: '/active',
                    isSub: false,
                },
                {
                    index: '10',
                    name: '成就列表',
                    path: '/achievement',
                    isSub: false,
                },
                {
                    index: '15',
                    name: '兑换商城',
                    path: '/voucher',
                    isSub: false,
                },
                {
                    index: '11',
                    name: 'GPTS待同步列表',
                    path: '/gpts-task',
                    isSub: false,
                },
                {
                    index: '12',
                    name: '分析',
                    path: '',
                    isSub: true,
                    sub: [
                        {
                            index: '12-9',
                            name: '网站全域访问量',
                            path: '/views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-1',
                            name: '首页访问量',
                            path: '/home-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-2',
                            name: '文生图页面访问量',
                            path: '/visual-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-3',
                            name: 'GPTS页面访问量',
                            path: '/gpts-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-4',
                            name: 'blog页面访问量',
                            path: '/blog-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-5',
                            name: '优化(文生文)页访问量',
                            path: '/optimize-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-6',
                            name: '优化(文生图)页访问量',
                            path: '/optimize-image-views-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-7',
                            name: '累计转化率',
                            path: '/convert-rate-analytics',
                            isSub: false,
                        },
                        {
                            index: '12-8',
                            name: '登录流失率',
                            path: '/churn-rate-analytics',
                            isSub: false,
                        },
                    ],
                },
                {
                    index: '13',
                    name: '配置',
                    path: '/config',
                    isSub: false,
                },
            ],
        };
    },
    created() {
        this.updateActiveMenu();
    },
    methods: {
        handleMenuItemClick(path) {
            if (path === '') {
                return;
            }
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        updateActiveMenu() {
            const currentPath = this.$route.path;
            console.log('path--->', currentPath);

            for (const menuItem of this.menuItems) {
                if (menuItem.path === currentPath) {
                    this.activeMenu = menuItem.index;
                    return;
                }

                if (menuItem.isSub && menuItem.sub) {
                    for (const subItem of menuItem.sub) {
                        if (subItem.path === currentPath) {
                            this.activeMenu = subItem.index;
                            return;
                        }
                    }
                }
            }
        },
    },
};
</script>

<style scoped>
.el-menu-item.is-active {
    background-color: #1890ff;
    color: #fff;
}

.menu-vertical .el-menu-item {
    display: block;
    border-bottom: 1px solid #eaeaea;
    padding: 0 !important;
}

.menu-vertical .el-menu-item span {
    padding: 0 20px;
    font-weight: 700;
}
</style>
